import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useScope } from "@state/scopeContext.lib";
import { useWorkspacesList } from "@api/workspace.api";
import { WorkspaceAvatar } from "@design-system/Avatar/WorkspaceAvatar";
import { HStack } from "@design-system/HStack/HStack";
import { EMPTY_CELL_VALUE } from "@components/organizationView/clients/views/cells/lib";
import { MemberAccessLogRow } from "../memberAccessLogRow";

export const ClientCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MemberAccessLogRow, unknown>) => {
        const { organizationId } = useScope();
        const { data: clients } = useWorkspacesList(
            organizationId ? { organizationId } : undefined,
            { enabled: !!organizationId },
        );
        const client = clients?.find(
            (c) => c.id === row.original.clientWorkspaceId,
        );

        if (!client) {
            // A removed client keeps its access rows (no cascade delete on this
            // audit table) — fall back to the empty value rather than hiding the
            // row entirely.
            return <>{EMPTY_CELL_VALUE}</>;
        }

        return (
            <HStack gap={8} align="center">
                <WorkspaceAvatar workspace={client} size="xs" aria-hidden />
                <span>{client.name}</span>
            </HStack>
        );
    },
);
